
import React from 'react';

interface CountryInfoBannerProps {
  countrySlug: string;
  currentPage: number;
  searchTerm: string;
  citiesCount: number;
}

const CountryInfoBanner = ({ countrySlug, currentPage, searchTerm, citiesCount }: CountryInfoBannerProps) => {
  const isChina = countrySlug === 'china';
  const isIndia = countrySlug === 'india';

  if (currentPage !== 1 || searchTerm) return null;

  if (isChina) {
    return (
      <div className="mb-8 p-6 bg-red-50 rounded-xl">
        <h3 className="text-lg font-semibold text-brand-gray-900 mb-3">
          Why Choose Our Chinese Mental Health Network?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-brand-gray-700">
          <div>
            <h4 className="font-medium mb-2">🏙️ Complete Urban Coverage</h4>
            <p className="text-sm">From Beijing and Shanghai to emerging cities across all provinces</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">🗣️ Mandarin & Regional Languages</h4>
            <p className="text-sm">Therapists available in Mandarin, Cantonese, and regional dialects</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">💎 Premium Quality Care</h4>
            <p className="text-sm">Internationally trained professionals with local cultural understanding</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">🌐 Global Standards</h4>
            <p className="text-sm">Online sessions available worldwide with flexible scheduling</p>
          </div>
        </div>
      </div>
    );
  }

  if (isIndia) {
    return (
      <div className="mb-8 p-6 bg-blue-50 rounded-xl">
        <h3 className="text-lg font-semibold text-brand-gray-900 mb-3">
          Why Choose Our Indian Mental Health Network?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-brand-gray-700">
          <div>
            <h4 className="font-medium mb-2">🏥 Comprehensive Coverage</h4>
            <p className="text-sm">From metro cities like Mumbai and Delhi to emerging centers like Indore and Coimbatore</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">🌍 Multi-language Support</h4>
            <p className="text-sm">Therapists available in Hindi, English, Tamil, Telugu, Bengali, and regional languages</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">💰 Affordable Rates</h4>
            <p className="text-sm">Competitive pricing starting from ₹800-2000 per session</p>
          </div>
          <div>
            <h4 className="font-medium mb-2">📱 Online & Offline</h4>
            <p className="text-sm">Both video consultations and in-person appointments available</p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default CountryInfoBanner;
